import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#236267',
        secondary: '#0e484e'
      }
    }
  }
}

export default new Vuetify(opts)
